export default {
    ExpandedURL: 'Expanded URL',
    NumberOfVisit: 'Number Of Visit',
    NumberOfVisitMin: 'Number Of Visit Min',
    NumberOfVisitMax: 'Number Of Visit Max',
    ShortenedURL: 'Shortened URL'
}